import { createSelector } from 'reselect'
import { AppState } from 'store/store'

/**
 * @param state - the application state
 * @returns BusinessEntity - the BusinessEntity reducer
 */
export const selectBusinessEntityReducer = (state: AppState) => state.businessEntity

/**
 * Gets the BusinessEntity data from the BusinessEntity reducer
 */
export const selectBusinessEntity = createSelector(
  selectBusinessEntityReducer,
  (BusinessEntityReducer) => BusinessEntityReducer.data
)

/**
 * Gets the BusinessEntity meta from the BusinessEntity reducer
 */
export const selectBusinessEntityMeta = createSelector(
  selectBusinessEntityReducer,
  (BusinessEntityReducer) => BusinessEntityReducer.meta
)

/**
 * Gets the BusinessEntity error from the BusinessEntity reducer
 */
export const selectBusinessEntityError = createSelector(
  selectBusinessEntityReducer,
  (BusinessEntityReducer) => BusinessEntityReducer.error
)

/**
 * Gets the BusinessEntity isFetching from the BusinessEntity reducer
 */
export const selectBusinessEntityIsFetching = createSelector(
  selectBusinessEntityReducer,
  (BusinessEntityReducer) => BusinessEntityReducer.isFetching
)
